import { RootState } from '@app/redux/root-reducer';

export const selectAddScheduleState = (store: RootState) =>
  store.managerDashboardReducer.addSchedule;
export const selectScheduleState = (store: RootState) => store.managerDashboardReducer.schedules;
export const selectUpdateScheduleStatusState = (store: RootState) =>
  store.managerDashboardReducer.updateScheduleStatus;
